import CaseStudyFilter from '../case-studies/caseStudyFilter';
import React from 'react';

const CaseStudyFilters = props => {
  const openIndustry =
    window.DEFAULT_FILTERS.industry.length > 0 ? true : false;

  const expandTopicsFilter = () => {
    if (props.isMobile) return false;

    if (openIndustry) {
      return false;
    }

    return true;
  };

  return (
    <div className="insight-results__filters">
      <CaseStudyFilter
        count={props.count.topics}
        defaultValue={window.DEFAULT_FILTERS.topics}
        selected={props.selected.topics}
        name="topics"
        label="Topic"
        options={props.filters.topics}
        onChange={props.onChange}
        onClear={props.onClear}
        onSave={props.onSave}
        expanded={expandTopicsFilter()}
      />
      <CaseStudyFilter
        count={props.count.industry}
        defaultValue={window.DEFAULT_FILTERS.industry}
        selected={props.selected.industry}
        name="industry"
        label="Industry"
        options={props.filters.industry}
        onChange={props.onChange}
        onClear={props.onClear}
        onSave={props.onSave}
        expanded={openIndustry}
      />
      <CaseStudyFilter
        count={props.count.technology}
        defaultValue={window.DEFAULT_FILTERS.technology}
        selected={props.selected.technology}
        name="technology"
        label="Technology"
        options={props.filters.technology}
        onChange={props.onChange}
        onClear={props.onClear}
        onSave={props.onSave}
        expanded={false}
      />
    </div>
  );
};

CaseStudyFilters.propTypes = {};

export default CaseStudyFilters;
